module.exports = __webpack_public_path__ + "img/logo.205d5c1c.png";